export const ANNOTATION_UI_ATTRIBUTE = 'data-annotation-ui'

export const annotationUiProps = {
  [ANNOTATION_UI_ATTRIBUTE]: '',
}

export const isAnnotationUiEventTarget = (target: EventTarget | null) =>
  target instanceof Element && !!target.closest(`[${ANNOTATION_UI_ATTRIBUTE}]`)
